<template>
  <div class="list">
    <div class="container_wrap">
      <Header />

      <div class="list_container">
        <el-row :gutter="15">
          <el-col :span="7">
            <ul class="side_muen marb_15">
              <li>
                <a href="/memberSub?id=1&name=集团高管">集团高管</a>
              </li>
              <!-- <li>
                <a href="/memberSub?id=2&name=高管助理">高管助理</a>
              </li> -->
            </ul>

            <!-- <div class="marb_15">
              <NewsCompany />
            </div>

            <div class="marb_15">
              <NewsPic />
            </div> -->

          </el-col>
          <el-col :span="17">
            <div class="list_hd">
              <span class="list_hd_posi"></span>
              <span class="list_hd_page"><a href="/">首页</a> > </span>
              <span class="list_hd_page"
                ><a href="">领导成员</a> >
              </span>
              <span class="list_hd_page">列表</span>
            </div>

            <div class="special_list">
              <div class="member_hd">集团高管</div>
              <div class="member_list">
                <div class="member_wrap clearfloat" v-for="(item,index) in listJtgg" :key="index">
                  <!-- <div class="fl member_fl">
                    <img :src="item.img" alt="">
                  </div> -->
                  <div class="member_fl_inner">
                    <div class="member_tit">
                      {{item.name}} {{item.jobs}}
                    </div>
                    <div class="member_inner">
                      {{item.describe}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="member_hd">高管助理</div>
              <div class="member_list">
                <div class="member_wrap clearfloat" v-for="(item,index) in listJtgg" :key="index">
                  <div class="fl member_fl">
                    <img :src="item.img" alt="">
                  </div>
                  <div class="member_fl_inner">
                    <div class="member_tit">
                      {{item.name}} {{item.jobs}}
                    </div>
                    <div class="member_inner">
                      {{item.describe}}
                    </div>
                  </div>
                </div>
              </div> -->
              
            </div>

          </el-col>
        </el-row>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
// import NewsPic from "@/components/newsPic.vue";
// import NewsCompany from "@/components/newsCompany.vue";

export default {
  name: "member",
  components: {
    Header,
    Footer,
    // NewsPic,
    // NewsCompany
  },
  data() {
    return {
      name1: "专题专栏",
      name2: "",
      total: 0,
      pageSize: 20,
      currentPage: 1,
      list: [],
      newsJtdt: [],
      picList: [],
      listJtgg: [
        {
          name: '贾军政',
          img: require('../assets/img/member_img01.jpg'),
          jobs: '甘肃省公路航空旅游投资集团有限公司总经理助理、甘肃公航旅置业有限公司董事长',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
        {
          name: '刘今凯 ',
          img: require('../assets/img/member_img02.jpg'),
          jobs: '甘肃公航旅置业有限公司总经理 ',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
        {
          name: '任玉龙',
          img: require('../assets/img/member_img01.jpg'),
          jobs: '甘肃公航旅置业有限公司副总经理',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
        {
          name: '赵铁龙',
          img: require('../assets/img/member_img02.jpg'),
          jobs: '甘肃公航旅置业有限公司副总经理',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
        {
          name: '于双科',
          img: require('../assets/img/member_img01.jpg'),
          jobs: '甘肃公航旅置业有限公司副总经理',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
        {
          name: '马明军',
          img: require('../assets/img/member_img01.jpg'),
          jobs: '甘肃公航旅置业有限公司财务总监',
          describe: '中共党员，北京大学工商管理硕士，正高级会计师、高级经济师，国务院政府特殊津贴获得者，全国五一劳动奖章获得者，甘肃省领军人才。现任甘肃省公路航空旅游投资集团有限公司党委副书记、董事长。'
        },
      ]
    };
  },
  mounted() {
    var _this = this;
    _this.getZtzlNews();

    
  },
  methods: {
    async getZtzlNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/group/getGrouplistByNavId', {id: 20210202});
      _this.picList = data.data;
    },
  },
};
</script>

<style scoped>
</style>